module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-05.b0d9591c.jpg";